module.exports = __webpack_public_path__ + "img/sj.194b709c.png";